export const routesProjePaket = [
  {
    path: "/projepaket",
    name: "projepaket",
    component: () => import("@/views/proje_alt/projepaket/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Proje Paket",
      yetki: { k: [1010902] },
    },
  },
]
